import { format } from 'date-fns';

export const formatDate = {
  time: (date: Date | string): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, 'HH:mm');
  },
  
  fullDateTime: (date: Date | string): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, 'MMM d, yyyy HH:mm');
  },
  
  dateRange: (date: Date): string => {
    return format(date, 'LLL dd, y');
  },

  filename: (date: Date): string => {
    return format(date, 'yyyy-MM-dd_HH-mm');
  }
};